import { Transform } from 'class-transformer';

export function TransformBoolean({ toClassOnly = true } = {}) {
  return Transform(
    ({ value }) => {
      if (value === undefined || value === null) {
        return value;
      }
      if (typeof value === 'string') {
        return value === '1' || value.toLowerCase() === 'true';
      }
      if (typeof value === 'number') {
        return value === 1;
      }
      return Boolean(value);
    },
    { toClassOnly },
  );
}
